/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_DisclaimersInputs */

const en_ad_section_disclaimers = /** @type {(inputs: Ad_Section_DisclaimersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disclaimers`)
};

const fr_ad_section_disclaimers = /** @type {(inputs: Ad_Section_DisclaimersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avertissements`)
};

const de_ad_section_disclaimers = /** @type {(inputs: Ad_Section_DisclaimersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haftungsausschluss`)
};

const it_ad_section_disclaimers = /** @type {(inputs: Ad_Section_DisclaimersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dichiarazioni di non responsabilità`)
};

const ru_ad_section_disclaimers = /** @type {(inputs: Ad_Section_DisclaimersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отказ от ответственности`)
};

const es_ad_section_disclaimers = /** @type {(inputs: Ad_Section_DisclaimersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargo de responsabilidad`)
};

const zh_cn2_ad_section_disclaimers = /** @type {(inputs: Ad_Section_DisclaimersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免责声明`)
};

const ja_ad_section_disclaimers = /** @type {(inputs: Ad_Section_DisclaimersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免責事項`)
};

const hi_ad_section_disclaimers = /** @type {(inputs: Ad_Section_DisclaimersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अस्वीकरण`)
};

const pt_pt2_ad_section_disclaimers = /** @type {(inputs: Ad_Section_DisclaimersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avisos legais`)
};

/**
* | output |
* | --- |
* | "Disclaimers" |
*
* @param {Ad_Section_DisclaimersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_disclaimers = /** @type {((inputs?: Ad_Section_DisclaimersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_DisclaimersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_section_disclaimers(inputs)
	if (locale === "de") return de_ad_section_disclaimers(inputs)
	if (locale === "it") return it_ad_section_disclaimers(inputs)
	if (locale === "ru") return ru_ad_section_disclaimers(inputs)
	if (locale === "es") return es_ad_section_disclaimers(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_section_disclaimers(inputs)
	if (locale === "ja") return ja_ad_section_disclaimers(inputs)
	if (locale === "hi") return hi_ad_section_disclaimers(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_section_disclaimers(inputs)
	return en_ad_section_disclaimers(inputs)
});